import { Component, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-general',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskDirective
  ],
  templateUrl: './input-general.component.html',
})
export class InputGeneralComponent {
  private translate = inject(TranslateService);

  formControlGeneral = input<FormControl | AbstractControl | null>(new FormControl());
  label = input('');
  placeholder = input('');
  mask = input('');
  prefix = input('');
  type = input('');
  suffix = input('');
  thousandSeparator = input('');
  allowNegativeNumbers = input(false);
  maxlength = input(0);
  typeInput = input('');
  pattern = input('');

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }

  getInputGeneral(): FormControl {
    return this.formControlGeneral() as FormControl;
  }

  getErrorMessage(): string {
    const control = this.formControlGeneral();
    if (!control || !control.errors) return '';

    const errors = control.errors;

    if (errors['required']) {
      return this.translate.instant('inputs.required');
    }
    if (errors['minlength']) {
      return this.translate.instant('inputs.minlength', { requiredLength: errors['minlength'].requiredLength });
    }
    if (errors['maxlength']) {
      return this.translate.instant('inputs.maxlength', { requiredLength: errors['maxlength'].requiredLength });
    }
    if (errors['min']) {
      return this.translate.instant('inputs.min', { min: errors['min'].min });
    }
    if (errors['max']) {
      return this.translate.instant('inputs.max', { max: errors['max'].max });
    }
    if (errors['pattern']) {
      return this.translate.instant('inputs.invalidFormat');
    }

    return '';
  }
}
